import { render, staticRenderFns } from "./available-slots-results.vue?vue&type=template&id=38f5814d&scoped=true"
import script from "./available-slots-results.vue?vue&type=script&lang=js"
export * from "./available-slots-results.vue?vue&type=script&lang=js"
import style0 from "./available-slots-results.vue?vue&type=style&index=0&id=38f5814d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f5814d",
  null
  
)

export default component.exports